// The digits of a typed phone number; an empty field gives ''.
export const toPhoneDigits = (value) => String(value ?? '').replace(/\D/g, '');
